import {lazy} from 'react';

export const GridLazy = lazy(() => import(/* webpackChunkName: "grid" */ '.'));
